<template>
  <Modal
    hide-close-button
    :modal-style="{ maxWidth: '500px' }"
    offset-menu
    persistent
    :title="$t('modals.brand_profile_default_confirm_modal.title')"
  >
    <div
      class="q-pa-md rounded-borders"
      style="background-color: #f5f7f9"
    >
      <p>
        <i18n-t
          keypath="modals.brand_profile_default_confirm_modal.heading"
          scope="global"
        >
          <template #brandProfile>
            <strong>{{
              $t("modals.brand_profile_default_confirm_modal.brand_profile")
            }}</strong>
          </template>
          <template #brandName>
            {{ brandName }}
          </template>
        </i18n-t>
      </p>
      <div
        class="q-pa-md rounded-borders text-left"
        style="background-color: #fffbe6"
      >
        <p class="row no-wrap q-gutter-sm">
          <i class="material-icons">info</i>
          <span>{{
            $t("modals.brand_profile_default_confirm_modal.impact_message", {
              organisationName,
            })
          }}</span>
        </p>
        <ul class="q-mb-none">
          <li>
            {{
              $t(
                "modals.brand_profile_default_confirm_modal.curated_email_reports"
              )
            }}
          </li>
          <li>
            {{
              $t("modals.brand_profile_default_confirm_modal.scheduled_reports")
            }}
          </li>
          <li>
            {{
              $t(
                "modals.brand_profile_default_confirm_modal.instant_insights_reports"
              )
            }}
          </li>
          <li>
            {{
              $t("modals.brand_profile_default_confirm_modal.audience_reports")
            }}
          </li>
          <li>
            {{
              $t("modals.brand_profile_default_confirm_modal.social_reports")
            }}
          </li>
          <li>
            {{
              $t(
                "modals.brand_profile_default_confirm_modal.tagged_mention_reports"
              )
            }}
          </li>
          <li>
            {{
              $t(
                "modals.brand_profile_default_confirm_modal.transcript_reports"
              )
            }}
          </li>
        </ul>
      </div>
    </div>
    <template #buttons>
      <BaseButton
        color="secondary"
        :label="$t('global.cancel')"
        new-design
        @click="cancel"
      />
      <BaseButton
        color="danger"
        :label="$t('global.ok')"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "BrandProfileDefaultConfirmModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    brandName: {
      type: String,
      required: true,
    },
    organisationName: {
      type: String,
      required: true,
    },
  },
  emits: ["confirm"],
  methods: {
    cancel() {
      this.$modals.close("BrandProfileDefaultConfirmModal");
    },
    confirm() {
      this.$emit("confirm");
      this.$modals.close("BrandProfileDefaultConfirmModal");
    },
  },
};
</script>
